/* eslint-disable dot-notation */
import { useCallback, useEffect, useState } from 'preact/hooks';
import { ROOT_ID } from '../constants';
import { RefObject } from 'preact';
import { useDeviceState } from './useDeviceState';

export const useSticky = (
  scrollElement: Element | null,
  distanceFromTop: number,
  scrollChildRef: RefObject<HTMLElement> | null,
  setDistance: (distance: number) => void,
): boolean => {
  const [elementTop, setTop] = useState<number | null>(null);
  const { isDesktop } = useDeviceState();
  const isMobile = !isDesktop;
  const root = document.getElementById(ROOT_ID);

  const onScroll = useCallback(
    () => {
      if (isMobile) {
        const box =
          typeof scrollChildRef?.current?.['getBoundingClientRect'] !== 'undefined' &&
          scrollChildRef?.current?.getBoundingClientRect();

        const parentContainer =
          root?.shadowRoot?.querySelector('#uc-center-container') ||
          root?.shadowRoot?.querySelector('#uc-side-container');

        const parentBox = parentContainer?.getBoundingClientRect();

        if (parentBox && box) {
          const distance = parentBox.top - (box.top - 1);

          setTop(distance);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scrollChildRef],
  );

  useEffect(() => {
    if (isMobile) {
      const box =
        typeof scrollChildRef?.current?.['getBoundingClientRect'] !== 'undefined' &&
        scrollChildRef?.current?.getBoundingClientRect();
      const parentBox = scrollElement?.getBoundingClientRect();

      if (parentBox && box) {
        const distance = parentBox.top - (box.top - 1);
        setTop(distance);
        setDistance(distance);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setDistance, scrollChildRef, scrollElement]);

  useEffect(() => {
    if (isMobile) {
      scrollElement?.addEventListener('scroll', onScroll);
    }

    return () => (isMobile ? scrollElement?.removeEventListener('scroll', onScroll) : {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollElement, onScroll]);

  if (elementTop !== null) {
    const parentContainer =
      root?.shadowRoot?.querySelector('#uc-center-container') || root?.shadowRoot?.querySelector('#uc-side-container');
    const parentContainerBox = parentContainer?.getBoundingClientRect();
    const scrollParentBox = scrollElement?.getBoundingClientRect();

    if (parentContainerBox && scrollParentBox) {
      // We need the compensation because we can actually use the uc-side-container on mobile
      const paddingCompensation = root?.shadowRoot?.querySelector('#uc-center-container') ? 1 : 0;
      const elTop =
        parentContainerBox.top === 0 || scrollParentBox?.top === 0 ? elementTop + paddingCompensation : elementTop;

      return Math.trunc(elTop) >= distanceFromTop;
    }
  }

  return false;
};
